import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import {
  cityValidatorRequired,
  companyNameValidatorRequired,
  countryValidatorRequired,
  emailValidatorRequired,
  phoneValidatorRequired,
  postalCodeGenericValidator,
  postalCodePolandValidator,
  provinceValidator,
  regonValidator,
  streetHouseNumberValidatorRequired,
  streetValidatorRequired,
} from "../../../../../utilities/validators";
import { trimmedString } from "../../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.OWNER_COMPANY_DATA]: yup.object({
    [ComponentId.NAME]: trimmedString.onlyIfFieldIsVisible(
      companyNameValidatorRequired
    ),
    [ComponentId.REGON]: yup.string().onlyIfFieldIsVisible(regonValidator),
    [ComponentId.PHONE]: phoneValidatorRequired("companyphone"),
    [ComponentId.EMAIL]: trimmedString.onlyIfFieldIsVisible(
      emailValidatorRequired
    ),
    [ComponentId.STREET]: trimmedString.onlyIfFieldIsVisible(
      streetValidatorRequired
    ),
    [ComponentId.STREET_2]: trimmedString.onlyIfFieldIsVisible(
      streetHouseNumberValidatorRequired
    ),
    [ComponentId.ZIP_CODE_PL]: trimmedString.onlyIfFieldIsVisible(
      postalCodePolandValidator
    ),
    [ComponentId.ZIP_CODE_GENERIC]: trimmedString.onlyIfFieldIsVisible(
      postalCodeGenericValidator
    ),
    [ComponentId.CITY]: trimmedString.onlyIfFieldIsVisible(
      cityValidatorRequired
    ),
    [ComponentId.COUNTRY]: yup
      .object()
      .onlyIfFieldIsVisible(countryValidatorRequired),
    [ComponentId.PROVINCE]: trimmedString.onlyIfFieldIsVisible(
      provinceValidator
    ),
  }),
};
